/**
 * KTO ZROBIŁ WPIS W AUDYCIE — rozpoznanie sprawcy, osobno od ekranu.
 *
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  ⚠️⚠️ ZGŁOSZONE 01.09.2026: „w logi i statystyki → ślad audytu każde info jest jako »bez
 *  powiązanego konta« i nie bardzo wiadomo o co chodzi". I słusznie: ta plakietka miała znaczyć
 *  „konto zostało usunięte albo nigdy nie istniało", a wisiała przy KAŻDYM wpisie zrobionym nie
 *  przez człowieka — czyli przy większości. Wpis „Stan automatu … 1 pozycja" to robota PORTALU,
 *  a nie ślad po zniknionym koncie; ostrzeżenie w tym miejscu jest fałszywym alarmem.
 *
 *  ⚠️ `actorId === null` MA CO NAJMNIEJ PIĘĆ ZNACZEŃ i to jest sedno tego pliku: portal działający
 *  sam, agent, integracja po tokenie, token panelu Vending+, konto usunięte i nieudane logowanie
 *  na nieistniejący e-mail. Jedna plakietka na wszystkie pięć nie mówi nic o żadnym.
 *
 *  ⚠️ ROZPOZNAJEMY PO ZAPISANYM `actorEmail`, bo to on jest ODPISEM tożsamości z chwili zdarzenia
 *  (`logs.service.ts`) i tylko on przeżywa usunięcie konta. Markery są nasze i mają postać
 *  „(coś)" — prawdziwy e-mail nigdy nie zaczyna się nawiasem.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 */

export type RodzajAktora =
  /** Zalogowane konto portalu — normalny przypadek, bez plakietki. */
  | 'KONTO'
  /** Portal zrobił to sam (moduł, cykl, automatyczna operacja) — nie ma tu żadnego człowieka. */
  | 'PORTAL'
  /** Agent na maszynie klienta. */
  | 'AGENT'
  /** Integracja po tokenie API — w `actorEmail` stoi etykieta tokenu. */
  | 'API'
  /** Token panelu (Vending+). */
  | 'PANEL'
  /** Był e-mail, nie ma konta: usunięte albo nieudane logowanie na nieistniejący adres. */
  | 'BEZ_KONTA';

export function rodzajAktora(actorId: string | null, actorEmail: string): RodzajAktora {
  if (actorId !== null) return 'KONTO';

  const e = actorEmail.trim().toLowerCase();
  if (e.startsWith('(agent')) return 'AGENT';
  if (e.startsWith('(api')) return 'API';
  if (e.startsWith('(panel')) return 'PANEL';
  /**
   * ⚠️ „(konto nieznane)" ZNACZY PORTAL, a nie zaginione konto — i to jest ta pomyłka, którą widział
   * zgłaszający. Ten napis wstawia `config-down.service.ts`, gdy operację zakolejkował MODUŁ bez
   * żadnego `actorId`: stan rodzeństwa, domknięcie paczki obrazków, cykliczne wyrównania. Nikt
   * takiego konta nigdy nie miał, więc nie ma czego szukać na liście kont.
   */
  if (e.startsWith('(konto nieznane') || e.startsWith('(portal') || e.startsWith('(moduł') || e.startsWith('(modul')) {
    return 'PORTAL';
  }
  if (e.startsWith('(')) return 'PORTAL';
  return 'BEZ_KONTA';
}

/** Czy plakietka ma ostrzegać. Ostrzega WYŁĄCZNIE brak konta przy prawdziwym e-mailu. */
export function ostrzegaj(rodzaj: RodzajAktora): boolean {
  return rodzaj === 'BEZ_KONTA';
}
